module.exports = __webpack_public_path__ + "media/images/flags/cv-46937889269d9fe52f2d7906255c65f9.svg";